import { Create, useForm } from "@refinedev/antd";
import { Form, Input } from "antd";

import { BlockedUrlCreate } from "interfaces";


export const BlockedUrlCreatePage: React.FC = () => {
  const { formProps, saveButtonProps } = useForm<BlockedUrlCreate>();

  return (
    <Create saveButtonProps={saveButtonProps}>
      <Form {...formProps} layout="vertical">
        <Form.Item
          label="URL"
          name="url"
          extra="Например: podcast.ru/1548551619"
          rules={[{ required: true, message: "Укажите URL" }]}
        >
          <Input placeholder="podcast.ru/1548551619" />
        </Form.Item>
      </Form>
    </Create>
  );
};
